module.exports = __webpack_public_path__ + "static/media/rite-mobile.327c0725.png";